import angular from 'angular';
import books from '../../books';
import { accountListComponent } from './accountList';
import { balancesPanelComponent } from './balancesPanel';
import { bankAccountsPanelComponent } from './bankAccountsPanel';
import { gridButtonsComponent } from './gridButtons';
import { orgInfoComponent } from './orgInfo';
import { summaryPanelComponent } from './summaryPanel';

export default angular
  .module('csm.books.InitialSetup.dom', [
    'ui.grid',
    'ui.grid.edit',
    'ui.grid.selection',
    'ui.grid.cellNav',
    'ui.grid.emptyBaseLayer',
    'ui.grid.resizeColumns',
    books
  ])
  .component('accountList', accountListComponent)
  .component('balancesPanel', balancesPanelComponent)
  .component('bankAccountsPanel', bankAccountsPanelComponent)
  .component('gridButtons', gridButtonsComponent)
  .component('orgInfo', orgInfoComponent)
  .component('summaryPanel', summaryPanelComponent).name;
